import Typography from "@mui/material/Typography"
import { type FC } from "react"

import { formatPalletCount } from "../utils"

import { Button } from "@/components/common/Button"
import { TabletSuccessDialog } from "@/components/common/Modals/TabletSuccessDialog"
import { DATE_FORMAT } from "@/constants/formats"
import { HOLD_AREA_1 } from "@/constants/warehouse"
import type { GoodsReceipt } from "@/graphql/codegen/graphql"
import { formatDate } from "@/utils/date"

interface SoftReceiveSuccessDialogProps {
  goodsReceipt: GoodsReceipt | null
  onSoftReceiveSuccessSubmit: () => void
}

export const SoftReceiveSuccessDialog: FC<SoftReceiveSuccessDialogProps> = ({
  goodsReceipt,
  onSoftReceiveSuccessSubmit,
}) => {
  if (!goodsReceipt) {
    return null
  }

  return (
    <TabletSuccessDialog
      title={
        <>
          Products Soft <br /> Received
        </>
      }
      agrNumber={goodsReceipt.agrNumber}
      onClose={onSoftReceiveSuccessSubmit}
      actions={
        <Button appearance='outlined' variant='primary' onClick={onSoftReceiveSuccessSubmit} data-testid='done-button'>
          Done
        </Button>
      }
    >
      <Typography variant='subtitle1' color='primary' className='font-normal text-gray-900'>
        {formatPalletCount(goodsReceipt.softReceiveData?.deliveredPalletsCount ?? 0)} Soft Received
      </Typography>
      <Typography variant='subtitle1' color='primary' className='font-normal text-gray-900'>
        {HOLD_AREA_1}
      </Typography>
      <Typography variant='subtitle1' color='primary' className='font-normal text-gray-900'>
        {formatDate(goodsReceipt.softReceivedOn, DATE_FORMAT.US_DATE_TIME)}
      </Typography>
    </TabletSuccessDialog>
  )
}
